import { useFirestoreQuery } from '../../firebase/useFirestore'

/**
 * Alle updateverzoeken van alle organisaties, voor de Deccos-beheertenant.
 *
 * `scope: 'none'` haalt het gebruikelijke `CompagnyID == client`-filter weg;
 * de Firestore-regel op `UpdateRequests` staat deze lees alleen toe aan een lid
 * van de beheertenant (`isSuperTenantMember()`). Elders komt hij dus leeg
 * terug, en daarom staat `enabled` er: een geweigerde lees is geen fout maar
 * een lege lijst, en die wil je niet per ongeluk als 'geen verzoeken' tonen.
 *
 * Geen `orderBy`: een document zonder `Timestamp` valt daar stil uit weg.
 * Sorteren gebeurt op het resultaat, met sortUpdateRequests.
 * AI-CONTEXT: See docs/pitfalls.md#database-firestore-orderby-excludes-missing-field
 *
 * AI-CONTEXT: See docs/features/update-aanvragen.md
 *
 * @param {boolean} enabled - Of de zoekopdracht mag draaien
 * @param {(error: {code?: string}) => void} [onError] - Aangeroepen als de listener faalt
 * @returns {Array<object>|string} De verzoeken, of '' zolang er nog niets binnen is
 */
const useAllUpdateRequests = (enabled, onError) =>
    useFirestoreQuery('UpdateRequests', { scope: 'none', enabled, onError })

export default useAllUpdateRequests
